export default process.env.VUE_APP_CUSTOM_LABELS || ''
